<script>
  export let size = 24;
  export let color = 'gray';
  export let stroke = '#8F92A1';
</script>

<div
  class="flex items-center justify-center p-1 rounded-full hover:bg-{color}-200 transition delay-150"
>
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.125 7.125L16.875 16.875M16.875 7.125L7.125 16.875L16.875 7.125Z"
      {stroke}
      stroke-width="1.875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</div>
